export const BANK_CODES_FOR_ALL = {
  '081': '하나은행',
  '004': '국민은행',
  '088': '신한은행',
  '020': '우리은행',
  '011': '농협은행',
  '003': '기업은행',
  '002': '산업은행',
  '007': '수협은행',
  '089': '케이뱅크',
  '090': '카카오뱅크',
  '092': '토스뱅크',
  '023': 'SC제일은행',
  '027': '한국씨티은행',
  '031': '대구은행',
  '032': '부산은행',
  '034': '광주은행',
  '035': '제주은행',
  '037': '전북은행',
  '039': '경남은행',
  '008': '수출입은행',
  '045': '새마을금고중앙회',
  '048': '신협',
  '071': '우체국',
  '102': '대신저축은행',
  '103': '에스비아이저축은행',
  '104': '에이치케이저축은행',
  '105': '웰컴저축은행',
  '106': '신한저축은행',
  '052': '모건스탠리은행',
  '054': 'HSBC',
  '055': '도이치은행',
  '057': '제이피모건체이스은행',
  '058': '미즈호은행',
  '059': '엠유에프지은행',
  '060': 'BOA',
  '061': '비엔피파리바은행',
  '062': '중국공상은행',
  '063': '중국은행',
  '066': '교통은행',
  '067': '중국건설은행',
  '001': '한국은행',
  '012': '지역농축협',
  '374': '하나카드',
  '050': '저축은행',
  '051': '외국은행',
  '064': '산림조합중앙회',
  '076': '신용보증기금',
  '077': '기술보증기금',
  '091': '국세청',
  '093': '화재보험회사',
  '094': '캐피털사',
  '095': '경찰청',
  '096': '한국신용정보(주)',
  '097': '효성',
  '098': '청호',
  '099': '금융결제원',
  '101': '한국신용정보원',
  '209': '유안타증권',
  '218': 'KB증권',
  '221': '상상인증권',
  '222': '한양증권',
  '223': '리딩투자증권',
  '224': 'BNK투자증권',
  '225': 'IBK투자증권',
  '227': '다올투자증권',
  '238': '미래에셋증권',
  '240': '삼성증권',
  '243': '한국투자증권',
  '247': 'NH투자증권',
  '261': '교보증권',
  '262': '하이투자증권',
  '263': '현대차증권',
  '264': '키움증권',
  '265': '이베스트투자증권',
  '266': 'SK증권',
  '267': '대신증권',
  '269': '한화투자증권',
  '270': '하나증권',
  '271': '토스증권',
  '278': '신한투자증권',
  '279': 'DB금융투자',
  '280': '유진투자증권',
  '287': '메리츠증권주식회사',
  '288': '카카오페이증권',
  '290': '부국증권',
  '291': '신영증권',
  '292': '케이프투자증권',
  '293': '한국증권금융',
  '294': '한국포스증권',
  '299': '아주캐피탈',
  '361': 'BC카드',
  '364': '광주카드',
  '365': '삼성카드',
  '366': '신한카드',
  '367': '현대카드',
  '368': '롯데카드',
  '369': '수협카드',
  '370': '씨티카드',
  '371': 'NH카드',
  '372': '전북카드',
  '373': '제주카드',
  '381': 'KB국민카드',
  '431': '미래에셋생명',
  '432': '한화생명',
  '433': '교보라이프플래닛생명',
  '434': '현대라이프생명',
  '435': '라이나생명',
  '436': '교보생명',
  '437': '에이비엘생명',
  '438': '신한생명',
  '439': 'KB생명보험',
  '440': '농협생명',
  '441': '삼성화재',
  '442': '현대해상',
  '443': '동부화재',
  '444': 'KB손해보험',
  '445': '롯데손해보험',
  '446': '오렌지라이프생명보험',
  '447': '악사손해보험',
  '448': '메리츠화재',
  '449': '농협손해보험',
  '450': '푸르덴셜생명보험',
  '452': '삼성생명',
  '453': '흥국생명',
  '454': '한화생명보험',
  '455': 'AIA생명보험',
  '456': 'DGB생명보험',
  '457': 'DB생명보험',
  '458': 'KDB생명보험',
} as const;

export const BANK_KEYWORD_LIST = {
  '081': ['하나은행', 'HANA BANK', 'HNB', 'Hana Bank', '하나', 'KEB', 'KEB하나'],
  '004': ['국민은행', 'KOOKMIN BANK', 'KB', 'Kookmin Bank', '국민', 'KB', 'KB국민', 'KB은행'],
  '088': ['신한은행', 'SHINHAN BANK', 'SHB', 'Shinhan Bank', '신한'],
  '020': ['우리은행', 'WOORI BANK', 'WRI', 'Woori Bank', '우리'],
  '011': [
    '농협은행',
    'NATIONAL AGRICULTURAL COOPERATIVE FEDERATION',
    'NACF',
    'NH Bank',
    '농협',
    'NH',
    'NH농협',
    'NH은행',
  ],
  '003': [
    '기업은행',
    'INDUSTRIAL BANK OF KOREA',
    'IBK',
    'IBK',
    '기업',
    'IBK',
    'IBK기업',
    'IBK은행',
  ],
  '002': ['산업은행', 'KOREA DEVELOPMENT BANK', 'KDB', 'KDB', '산업', 'KDB', 'KDB산업', 'KDB은행'],
  '007': ['수협은행', 'Suhyup Bank', 'SUB', 'SUB', '수협'],
  '089': ['케이뱅크', 'K bank', 'K bank', 'K-Bank', '케이', 'K뱅크'],
  '090': ['카카오뱅크', 'kakaobank', 'kakaobank', 'kakaobank', '카카오'],
  '092': ['토스뱅크', 'Toss Innovation Co.,Ltd', 'Toss', 'Toss', '토스'],
  '023': [
    'SC제일은행',
    'Standard Chartered BANK',
    'SCBK',
    'SC Bank',
    'SC제일',
    'SC',
    '제일',
    '에스씨제일',
    '스탠다드차타드',
  ],
  '027': ['한국씨티은행', 'CITI BANK', 'CITI', 'Citibank Korea', '씨티', 'CITI', '한국씨티'],
  '031': [
    'iM뱅크(대구)',
    'IM BANK LTD',
    'IM',
    'IM Bank',
    '아이엠',
    'iM',
    'iM대구',
    '아이엠뱅크',
    '대구은행',
    'DGB',
  ],
  '032': ['부산은행', 'THE BANK OF PUSAN,LTD', 'BOP', 'Busan Bank', '부산'],
  '034': ['광주은행', 'THE KWANGJU BANK LTD', 'KJB', 'Kwangju Bank', '광주'],
  '035': ['제주은행', 'THE BANK OF CHEJU,LTD', 'BOC', 'Jeju Bank', '제주'],
  '037': ['전북은행', 'THE JEONBUK BANK LTD', 'JBB', 'Jeonbuk Bank', '전북'],
  '039': ['경남은행', 'THE GYOENGNAM BANK LTD', 'GNB', 'Gyeongnam Bank', '경남'],
  '008': ['수출입은행', 'THE EXPORT - IMPORT BANK OF KOREA', 'EIB', 'KOEXIMBANK', '수출입'],
  '045': [
    '새마을금고중앙회',
    'FEDERATION OF COMMUNITY CREDIT COOPERATIVES',
    'KFCC',
    'KFCC',
    '새마을',
    '새마을금고',
  ],
  '048': ['신협', 'CREDIT UNION', 'CU', 'NCUFK'],
  '071': ['우체국', 'POST - OFFICE', 'POST', 'Korea Post', '우체국은행'],
  '102': [
    '대신저축은행',
    'Daishin Savings Bank',
    'Daishin Savings Bank',
    'Daishin Savings Bank',
    '대신',
  ],
  '103': [
    '에스비아이저축은행',
    'SBI Savings Bank',
    'SBI Savings Bank',
    'SBI Savings Bank',
    '에스비아이',
    'SBI',
  ],
  '104': [
    '에이치케이저축은행',
    'HK Savings Bank',
    'HK Savings Bank',
    'HK Savings Bank',
    '에이치케이',
    'HK',
  ],
  '105': [
    '웰컴저축은행',
    'Welcome Savings Bank',
    'Welcome Savings Bank',
    'Welcome Savings Bank',
    '웰컴',
    '웰컴저축',
  ],
  '106': [
    '신한저축은행',
    'Shinhansavings bank',
    'Shinhansavings bank',
    'Shinhansavings bank',
    '신한저축',
  ],
  '052': [
    '모건스탠리은행',
    'MoranStanley Bank',
    'MoranStanley Bank',
    'MoranStanley Bank',
    '모건스탠리',
    'MS',
  ],
  '054': ['HSBC', 'HSBC BANK', 'HSBC', 'HSBC'],
  '055': ['도이치은행', 'DEUTSCHE BANK', 'DEUT', 'Deutsche Bank', '도이치'],
  '057': [
    '제이피모건체이스은행',
    'JP Morgan Chase',
    'JP Morgan Chase',
    'JPMorgan Chase',
    'JP모건',
    'JPM',
  ],
  '058': ['미즈호은행', 'Mizuho Bank. Ltd., Seoul Branch', 'Mizuho', 'Mizuho Bank', '미즈호'],
  '059': ['엠유에프지은행', 'MUFG Bank', 'MUFG', 'MUFG', '엠유에프지'],
  '060': ['BOA', 'BANK OF AMERICA', 'BOA', 'Bank America'],
  '061': [
    '비엔피파리바은행',
    'BNP PARIBAS CORPORATE & INVESTMENT BANKING',
    'BNPP',
    'BNP Paribas',
    '비엔피파리바',
    'BNP',
    'BNP파리바',
  ],
  '062': ['중국공상은행', 'Industrial and Commercial Bank of China', 'ICBC', 'ICBC', '중국공상'],
  '063': ['중국은행', 'Bank of China Seoul Branch', 'BOCSB', 'BOCSB', '중국공상'],
  '066': [
    '교통은행',
    'Bank of Communications Co., Ltd.',
    'Bank of Communications Co., Ltd.',
    'Bank of Communications Co., Ltd.',
    '교통',
  ],
  '067': [
    '중국건설은행',
    'China Construction Bank',
    'China Construction Bank',
    'China Construction Bank',
    '중국건설',
    'CCB',
  ],
  '001': ['한국은행', 'BANK OF KOREA', 'BOK', 'BOK'],
  '012': ['지역농축협', 'NATIONAL AGRICULTURAL COOPERATIVE FEDERATION', 'NACF', 'AGRICULTURAL'],
  '374': ['하나카드'],
  '050': ['저축은행', 'KOREA FEDERATION OF MUTUAL SAVINGS', 'SB', 'KMSFC'],
  '051': ['외국은행', 'BOF', 'FOREIGNBANK'],
  '064': ['산림조합중앙회', 'NATIONAL FORESTRY COOPERATIVE FEDERATION', 'NFCF', 'NFCF'],
  '076': ['신용보증기금', 'KOREA CREDIT GUARANTEE FUND', 'KCGF', 'KCGF', '신보'],
  '077': ['기술보증기금', 'Korea Technology Finance Corporation', 'KTFC', 'KTFC', '기보'],
  '091': ['국세청', 'National Tax Service', 'National Tax Service'],
  '093': ['화재보험회사'],
  '094': ['캐피털사'],
  '095': ['경찰청'],
  '096': ['한국신용정보(주)', 'NATIONAL INFORMATION CREDIT EVALUATION INC', 'NICE', 'NICE'],
  '097': ['효성'],
  '098': ['청호'],
  '099': ['금융결제원', 'KOREA FINANCIAL TELECOM&CLEAR INST'],
  '101': [
    '한국신용정보원',
    'Korea Credit Information Services',
    'Korea Credit Information Services',
  ],
  '209': ['유안타증권', 'Yuanta Securities Korea co., Ltd.', 'Yuanta Sec.'],
  '218': ['KB증권', 'KB Securities co., Ltd.', 'KB Securities'],
  '221': [
    '상상인증권',
    'SANGSNAGIN INVESTMENT & SECURITIES CO.,LTD.',
    'SANGSNAGIN INVESTMENT & SECURITIES CO.,LTD.',
    'SANGSNAGIN INVESTMENT & SECURITIES CO.,LTD.',
  ],
  '222': [
    '한양증권',
    'HANYANG Securities CO., Ltd.',
    'HANYANG Securities CO., Ltd.',
    'HANYANG Securities CO., Ltd.',
  ],
  '223': [
    '리딩투자증권',
    'Leading Investment & securities co., ltd',
    'Leading Investment & securities co., ltd',
    'Leading Investment & securities co., ltd',
  ],
  '224': ['BNK투자증권', 'BNK Investment & Securities Co., Ltd.,', 'BNK', 'BNK Invest.'],
  '225': [
    'IBK투자증권',
    'IBK Securities Co., Ltd.',
    'IBK Securities Co., Ltd.',
    'IBK Securities Co., Ltd.',
  ],
  '227': ['다올투자증권', 'DAOL Investment & Securities', 'DAOL', 'DAOL Invest.'],
  '238': ['미래에셋증권', 'MIRAE ASSET SECURITIES CO., LTD.', 'MIRAE ASSET SECURITIES CO., LTD.'],
  '240': ['삼성증권', 'Samsung Securities Co., Ltd.,', 'Samsung Sec.'],
  '243': ['한국투자증권', 'Korea Investment & Securities Co., Ltd.,', 'Korea Invest.'],
  '247': ['NH투자증권', 'NH Investment & Securities Co., Ltd.,', 'NH Investment'],
  '261': ['교보증권', 'Kyobo Securities Co., Ltd,', 'Kyobo Sec.'],
  '262': ['하이투자증권', 'HI Investment & Securities Co., Ltd.,', 'HI Investment'],
  '263': ['현대차증권', 'Hyundai Motor Securities Co., Ltd.', 'Hyundai Motor Securities Co., Ltd.'],
  '264': ['키움증권', 'Kiwoom Securities Co., Ltd.,', 'Kiwoom Sec.'],
  '265': ['LS증권', 'LS Investment & Securities Co., Ltd.,', 'LS'],
  '266': ['SK증권', 'SK Securities Co., Ltd.,', 'SK Securities'],
  '267': ['대신증권', 'Daishin Securities Co., Ltd.,', 'Daishin Sec.'],
  '269': ['한화투자증권', 'Hanwha Investment & Securities Co., Ltd.,', 'Hanwha Invest.'],
  '270': ['하나증권', 'Hana Securities co., Ltd.', 'Hana Securities co., Ltd.'],
  '271': ['토스증권', 'Toss Securities Co., Ltd', 'Toss Securities Co., Ltd'],
  '278': ['신한투자증권', 'Shinhan Securities Co., Ltd.,', 'Shinhan Invest'],
  '279': ['DB금융투자', 'DB Financial Investment Co.,Ltd.', 'DB Financial'],
  '280': ['유진투자증권', 'Eugene Investment & Securities Co., Ltd.,', 'Eugene Invest.'],
  '287': ['메리츠증권주식회사', 'Meritz Securities Co., Ltd.,', 'Meritz Sec.'],
  '288': ['카카오페이증권', 'kakaopay securities Corp.', 'pay', 'kakaopay securities Corp.'],
  '290': ['부국증권', 'Bookook Securities Co., Ltd.,', 'Bookook Sec.'],
  '291': ['신영증권', 'Shinyoung Securities Co., Ltd.,', 'Shinyoung Sec.'],
  '292': ['케이프투자증권', 'CAPE Investment & Securities Co., Ltd.', 'Cape Invest.'],
  '293': [
    '한국증권금융',
    'Korea Securities Finance Corp.',
    'Korea Securities Finance Corp.',
    'Korea Securities Finance Corp.',
  ],
  '294': ['한국포스증권', 'Korea Foss Securities Co.,Ltd', 'Korea Foss'],
  '299': ['아주캐피탈', 'AJC', 'AJC'],
  '304': [
    '현대캐피탈',
    'Hyundai Capital Co., Ltd',
    'Hyundai Capital Co., Ltd',
    'Hyundai Capital Co., Ltd',
  ],
  '361': ['BC카드'],
  '364': ['광주카드'],
  '365': ['삼성카드'],
  '366': ['신한카드'],
  '367': ['현대카드'],
  '368': ['롯데카드'],
  '369': ['수협카드'],
  '370': ['씨티카드'],
  '371': ['NH카드'],
  '372': ['전북카드'],
  '373': ['제주카드'],
  '381': ['KB국민카드'],
  '431': [
    '미래에셋생명',
    'Mirae Asset Life Insurance Co., Ltd.',
    'Mirae Asset Life Insurance Co., Ltd.',
    'Mirae Asset Life Insurance Co., Ltd.',
  ],
  '432': ['한화생명', 'Hanwhalife Insurance Co., Ltd', 'Hanwhalife'],
  '433': ['교보라이프플래닛생명', 'Kyobo Lifeplanet Life Insurance Company', 'Kyobo Lifeplanet'],
  '434': ['현대라이프생명', 'Hyundai Life Insurance', 'Hyundai Life'],
  '435': ['라이나생명', 'Lina Korea', 'Lina Korea'],
  '436': ['교보생명', 'Kyobo Life Insurance Co., Ltd', 'Kyobo Life'],
  '437': ['에이비엘생명', 'ABL Life Insurance Co., Ltd', 'ABL Life'],
  '438': ['신한생명', 'Shinhan Life Insurance Co., Ltd', 'Shinhan Life'],
  '439': ['KB생명보험', 'KB Life Insurance CO., Ltd', 'KB Life'],
  '440': ['농협생명', 'NongHyup Life Insurance Co., Ltd', 'NongHyup Life'],
  '441': ['삼성화재', 'Samsung Fire&Marine Insurance Co., Ltd', 'Samsung Fire&Marine'],
  '442': ['현대해상', 'Hyundai Marine&Fire Insurance', 'Hyundai Marine&Fire'],
  '443': ['동부화재', 'Dongbu Insurance Co., Ltd', 'Dongbu Insurance'],
  '444': ['KB손해보험', 'KB Insurance Co., Ltd', 'KB Insurance'],
  '445': [
    '롯데손해보험',
    'Lotte Insurance Co., Ltd.',
    'Lotte Insurance Co., Ltd.',
    'Lotte Insurance Co., Ltd.',
  ],
  '446': [
    '오렌지라이프생명보험',
    'Orange Life Insurance., Ltd.',
    'Orange Life Insurance., Ltd.',
    'Orange Life Insurance., Ltd.',
  ],
  '447': [
    '악사손해보험',
    'AXA General Insurance Co., Ltd.',
    'AXA General Insurance Co., Ltd.',
    'AXA General Insurance Co., Ltd.',
  ],
  '448': [
    '메리츠화재',
    'Meritz Fire & Marine Insurance Co. Ltd.',
    'Meritz Fire & Marine Insurance Co. Ltd.',
    'Meritz Fire & Marine Insurance Co. Ltd.',
  ],
  '449': [
    '농협손해보험',
    'NongHyup Property & Casualty Insurance Co.',
    'NongHyup Property & Casualty',
  ],
  '450': ['푸르덴셜생명보험', 'POK', 'POK'],
  '452': ['삼성생명', 'Samsung Life Insurance Co., Ltd', 'Samsung Life Insurance'],
  '453': [
    '흥국생명',
    'Heungkuk Life Insurance Co., Ltd.',
    'Heungkuk Life Insurance Co., Ltd.',
    'Heungkuk Life Insurance Co., Ltd.',
  ],
  '454': ['한화생명보험', 'Hanwha General Insurance Co.,Ltd', 'Hanwha General Ins'],
  '455': ['AIA생명보험', 'AIA Life Insurance Co.,Ltd', 'AIA Life Insurance'],
  '456': ['DGB생명보험', 'DGB Life', 'DGB Life'],
  '457': ['DB생명보험', 'DBLI', 'DBLI', 'DBLI'],
  '458': [
    'KDB생명보험',
    'KDB Life Insurance Co., Ltd.',
    'KDB Life Insurance Co., Ltd.',
    'KDB Life Insurance Co., Ltd.',
  ],
};
export const BANK_CODES_FOR_ALL_MAP = new Map([
  ['081', '하나은행'],
  ['004', '국민은행'],
  ['088', '신한은행'],
  ['020', '우리은행'],
  ['011', '농협은행'],
  ['003', '기업은행'],
  ['002', '산업은행'],
  ['007', '수협은행'],
  ['089', '케이뱅크'],
  ['090', '카카오뱅크'],
  ['092', '토스뱅크'],
  ['023', 'SC제일은행'],
  ['027', '한국씨티은행'],
  ['031', '대구은행'],
  ['032', '부산은행'],
  ['034', '광주은행'],
  ['035', '제주은행'],
  ['037', '전북은행'],
  ['039', '경남은행'],
  ['008', '수출입은행'],
  ['045', '새마을금고중앙회'],
  ['048', '신협'],
  ['071', '우체국'],
  ['102', '대신저축은행'],
  ['103', '에스비아이저축은행'],
  ['104', '에이치케이저축은행'],
  ['105', '웰컴저축은행'],
  ['106', '신한저축은행'],
  ['052', '모건스탠리은행'],
  ['054', 'HSBC'],
  ['055', '도이치은행'],
  ['057', '제이피모건체이스은행'],
  ['058', '미즈호은행'],
  ['059', '엠유에프지은행'],
  ['060', 'BOA'],
  ['061', '비엔피파리바은행'],
  ['062', '중국공상은행'],
  ['063', '중국은행'],
  ['066', '교통은행'],
  ['067', '중국건설은행'],
  ['001', '한국은행'],
  ['012', '지역농축협'],
  ['374', '하나카드'],
  ['050', '저축은행'],
  ['051', '외국은행'],
  ['064', '산림조합중앙회'],
  ['076', '신용보증기금'],
  ['077', '기술보증기금'],
  ['091', '국세청'],
  ['093', '화재보험회사'],
  ['094', '캐피털사'],
  ['095', '경찰청'],
  ['096', '한국신용정보(주)'],
  ['097', '효성'],
  ['098', '청호'],
  ['099', '금융결제원'],
  ['101', '한국신용정보원'],
  ['209', '유안타증권'],
  ['218', 'KB증권'],
  ['221', '상상인증권'],
  ['222', '한양증권'],
  ['223', '리딩투자증권'],
  ['224', 'BNK투자증권'],
  ['225', 'IBK투자증권'],
  ['227', '다올투자증권'],
  ['238', '미래에셋증권'],
  ['240', '삼성증권'],
  ['243', '한국투자증권'],
  ['247', 'NH투자증권'],
  ['261', '교보증권'],
  ['262', '하이투자증권'],
  ['263', '현대차증권'],
  ['264', '키움증권'],
  ['265', '이베스트투자증권'],
  ['266', 'SK증권'],
  ['267', '대신증권'],
  ['269', '한화투자증권'],
  ['270', '하나증권'],
  ['271', '토스증권'],
  ['278', '신한투자증권'],
  ['279', 'DB금융투자'],
  ['280', '유진투자증권'],
  ['287', '메리츠증권주식회사'],
  ['288', '카카오페이증권'],
  ['290', '부국증권'],
  ['291', '신영증권'],
  ['292', '케이프투자증권'],
  ['293', '한국증권금융'],
  ['294', '한국포스증권'],
  ['299', '아주캐피탈'],
  ['361', 'BC카드'],
  ['364', '광주카드'],
  ['365', '삼성카드'],
  ['366', '신한카드'],
  ['367', '현대카드'],
  ['368', '롯데카드'],
  ['369', '수협카드'],
  ['370', '씨티카드'],
  ['371', 'NH카드'],
  ['372', '전북카드'],
  ['373', '제주카드'],
  ['381', 'KB국민카드'],
  ['431', '미래에셋생명'],
  ['432', '한화생명'],
  ['433', '교보라이프플래닛생명'],
  ['434', '현대라이프생명'],
  ['435', '라이나생명'],
  ['436', '교보생명'],
  ['437', '에이비엘생명'],
  ['438', '신한생명'],
  ['439', 'KB생명보험'],
  ['440', '농협생명'],
  ['441', '삼성화재'],
  ['442', '현대해상'],
  ['443', '동부화재'],
  ['444', 'KB손해보험'],
  ['445', '롯데손해보험'],
  ['446', '오렌지라이프생명보험'],
  ['447', '악사손해보험'],
  ['448', '메리츠화재'],
  ['449', '농협손해보험'],
  ['450', '푸르덴셜생명보험'],
  ['452', '삼성생명'],
  ['453', '흥국생명'],
  ['454', '한화생명보험'],
  ['455', 'AIA생명보험'],
  ['456', 'DGB생명보험'],
  ['457', 'DB생명보험'],
  ['458', 'KDB생명보험'],
]);

export const SECURITIES_CODES = {
  '0209': '유안타증권',
  '0218': 'KB증권',
  '0238': '미래에셋증권',
  '0240': '삼성증권',
  '0243': '한국투자증권',
  '0247': 'NH투자증권',
  '0261': '교보증권',
  '0264': '키움증권',
  '0265': 'LS증권',
  '0266': 'SK증권',
  '0267': '대신증권',
  '1267': '크레온',
  '0269': '한화투자증권',
  '0270': '하나금융투자',
  '0278': '신한금융투자',
  '0279': 'DB금융투자',
  '0280': '유진투자증권',
  '0287': '메리츠종합금융증권',
  '1247': 'NH모바일증권',
  '0262': '하이투자증권',
  '0225': 'IBK투자증권',
  '0227': '다올투자증권',
} as const;

export const BANK_CODES = {
  '001': '하나은행',
  '003': '기업은행',
  '004': '국민은행',
  '020': '우리은행',
  '088': '신한은행',
  '011': '농협은행',
  '027': '씨티은행',
  '023': 'SC제일은행',
  '089': 'K뱅크',
  '090': '카카오뱅크',
  '045': '새마을금고',
  '071': '우체국',
  '002': '산업은행',
  '007': '수협은행',
  '048': '신협은행',
  '032': '부산은행',
  '031': '대구은행',
  '034': '광주은행',
  '039': '경남은행',
  '037': '전북은행',
  '035': '제주은행',
  '081': 'KEB하나은행',
} as const;

export const CARD_CODES = {
  '002': '산업은행카드',
  '301': 'KB카드',
  '302': '현대카드',
  '303': '삼성카드',
  '304': 'NH카드',
  '305': 'BC카드',
  '306': '신한카드',
  '307': '씨티카드',
  '309': '우리카드',
  '311': '롯데카드',
  '313': '하나카드',
  '315': '전북카드',
  '316': '광주카드',
  '320': '수협카드',
  '321': '제주카드',
} as const;

export const ORGANIZATION_CODES = {
  ...BANK_CODES,
  ...CARD_CODES,
  ...SECURITIES_CODES,
} as const;

export type BankCodes = keyof typeof BANK_CODES;
export type BankCodesForAll = keyof typeof BANK_CODES_FOR_ALL;
export type SecuritiesCodes = keyof typeof SECURITIES_CODES;
export type CardCodes = keyof typeof CARD_CODES;
export type OrganizationCodes = keyof typeof ORGANIZATION_CODES;

export const TOSS_CARD_CODES = {
  '3K': '기업 BC',
  '46': '광주은행',
  '71': '롯데카드',
  '30': 'KDB산업은행',
  '31': 'BC카드',
  '51': '삼성카드',
  '38': '새마을금고',
  '41': '신한카드',
  '62': '신협',
  '36': '씨티카드',
  '33': '우리BC카드',
  W1: '우리카드',
  '37': '우체국예금보험',
  '39': '저축은행중앙회',
  '35': '전북은행',
  '42': '제주은행',
  '15': '카카오뱅크',
  '3A': '케이뱅크',
  '24': '토스뱅크',
  '21': '하나카드',
  '61': '현대카드',
  '11': 'KB국민카드',
  '91': 'NH농협카드',
  '34': 'Sh수협은행',
  '6D': '다이너스',
  '4M': '마스터',
  '3C': '유니온페이',
  '7A': '아메리칸 익스프레스',
  '4J': 'JCB',
  '4V': 'VISA',
};

export type TOSS_CARD_ORGANIZATION_CODES = keyof typeof TOSS_CARD_CODES;

export const ShortedBankName: Record<BankCodes | SecuritiesCodes, string> = {
  '001': '하나',
  '003': '기업',
  '004': '국민',
  '020': '우리',
  '088': '신한',
  '011': '농협',
  '027': '씨티',
  '023': 'SC제일',
  '089': '케이뱅크',
  '090': '카카오',
  '045': '새마을',
  '071': '우체국',
  '002': '산업',
  '007': '수협',
  '048': '신협',
  '032': '부산',
  '031': '대구',
  '034': '광주',
  '039': '경남',
  '037': '전북',
  '035': '제주',
  '081': 'KEB하나',
  ...SECURITIES_CODES,
};

export const getBankAccountText = ({
  alias,
  bankCode,
  accountNumber,
}: {
  alias: string;
  bankCode: BankCodes;
  accountNumber: string;
}): string => {
  return alias || `${ShortedBankName[bankCode]} ${accountNumber.slice(-4)}`;
};

export type BankLogos = Record<
  OrganizationCodes,
  {
    x1: string;
    x2: string;
  }
>;

export type BankLogosForAll = Partial<
  Record<
    BankCodesForAll,
    {
      x1: string;
      x2: string;
    }
  >
>;

export const STATIC_URL = 'https://static.clobe.ai';

export enum CARD_ORGANIZATION_KEYS {
  KDB_CARD = 'KDB_CARD',
  KB_CARD = 'KB_CARD',
  HYUNDAI_CARD = 'HYUNDAI_CARD',
  SAMSUNG_CARD = 'SAMSUNG_CARD',
  NH_CARD = 'NH_CARD',
  BC_CARD = 'BC_CARD',
  SHINHAN_CARD = 'SHINHAN_CARD',
  CITI_CARD = 'CITI_CARD',
  WOORI_CARD = 'WOORI_CARD',
  LOTTE_CARD = 'LOTTE_CARD',
  HANA_CARD = 'HANA_CARD',
  JB_CARD = 'JB_CARD',
  GWANGJU_CARD = 'GWANGJU_CARD',
  SOOHYUP_CARD = 'SOOHYUP_CARD',
  JEJU_CARD = 'JEJU_CARD',
}

export const CARD_ORGANIZATION_KEYS_TO_CODES = {
  [CARD_ORGANIZATION_KEYS.KDB_CARD]: '002',
  [CARD_ORGANIZATION_KEYS.KB_CARD]: '301',
  [CARD_ORGANIZATION_KEYS.HYUNDAI_CARD]: '302',
  [CARD_ORGANIZATION_KEYS.SAMSUNG_CARD]: '303',
  [CARD_ORGANIZATION_KEYS.NH_CARD]: '304',
  [CARD_ORGANIZATION_KEYS.BC_CARD]: '305',
  [CARD_ORGANIZATION_KEYS.SHINHAN_CARD]: '306',
  [CARD_ORGANIZATION_KEYS.CITI_CARD]: '307',
  [CARD_ORGANIZATION_KEYS.WOORI_CARD]: '309',
  [CARD_ORGANIZATION_KEYS.LOTTE_CARD]: '311',
  [CARD_ORGANIZATION_KEYS.HANA_CARD]: '313',
  [CARD_ORGANIZATION_KEYS.JB_CARD]: '315',
  [CARD_ORGANIZATION_KEYS.GWANGJU_CARD]: '316',
  [CARD_ORGANIZATION_KEYS.SOOHYUP_CARD]: '320',
  [CARD_ORGANIZATION_KEYS.JEJU_CARD]: '321',
} as const;

export const ORGANIZATION_LOGOS: BankLogos = {
  '001': {
    x1: `${STATIC_URL}/ico-bank-hana.png`,
    x2: `${STATIC_URL}/ico-bank-hana@2x.png`,
  },
  '003': {
    x1: `${STATIC_URL}/ico-bank-ibk.png`,
    x2: `${STATIC_URL}/ico-bank-ibk@2x.png`,
  },
  '004': {
    x1: `${STATIC_URL}/ico-bank-kb.png`,
    x2: `${STATIC_URL}/ico-bank-kb@2x.png`,
  },
  '020': {
    x1: `${STATIC_URL}/ico-bank-woori.png`,
    x2: `${STATIC_URL}/ico-bank-woori@2x.png`,
  },
  '088': {
    x1: `${STATIC_URL}/ico-bank-shinhan.png`,
    x2: `${STATIC_URL}/ico-bank-shinhan@2x.png`,
  },
  '011': {
    x1: `${STATIC_URL}/ico-bank-nonghyup.png`,
    x2: `${STATIC_URL}/ico-bank-nonghyup@2x.png`,
  },
  '027': {
    x1: `${STATIC_URL}/ico-bank-citi.png`,
    x2: `${STATIC_URL}/ico-bank-citi@2x.png`,
  },
  '023': {
    x1: `${STATIC_URL}/ico-bank-sc.png`,
    x2: `${STATIC_URL}/ico-bank-sc@2x.png`,
  },
  '089': {
    x1: `${STATIC_URL}/ico-bank-kbank.png`,
    x2: `${STATIC_URL}/ico-bank-kbank@2x.png`,
  },
  '090': {
    x1: `${STATIC_URL}/ico-bank-kakao.png`,
    x2: `${STATIC_URL}/ico-bank-kakao@2x.png`,
  },
  '045': {
    x1: `${STATIC_URL}/ico-bank-kfcc.png`,
    x2: `${STATIC_URL}/ico-bank-kfcc@2x.png`,
  },
  '071': {
    x1: `${STATIC_URL}/ico-bank-epost.png`,
    x2: `${STATIC_URL}/ico-bank-epost@2x.png`,
  },
  '002': {
    x1: `${STATIC_URL}/ico-bank-kdb.png`,
    x2: `${STATIC_URL}/ico-bank-kdb@2x.png`,
  },
  '007': {
    x1: `${STATIC_URL}/ico-bank-suhyup.png`,
    x2: `${STATIC_URL}/ico-bank-suhyup@2x.png`,
  },
  '048': {
    x1: `${STATIC_URL}/ico-bank-shinhyub.png`,
    x2: `${STATIC_URL}/ico-bank-shinhyub@2x.png`,
  },
  '032': {
    x1: `${STATIC_URL}/ico-bank-bnk.png`,
    x2: `${STATIC_URL}/ico-bank-bnk@2x.png`,
  },
  '031': {
    x1: `${STATIC_URL}/ico-bank-dgb.png`,
    x2: `${STATIC_URL}/ico-bank-dgb@2x.png`,
  },
  '034': {
    x1: `${STATIC_URL}/ico-bank-kwangju.png`,
    x2: `${STATIC_URL}/ico-bank-kwangju@2x.png`,
  },
  '039': {
    x1: `${STATIC_URL}/ico-bank-bnk.png`,
    x2: `${STATIC_URL}/ico-bank-bnk@2x.png`,
  },
  '037': {
    x1: `${STATIC_URL}/ico-bank-kwangju.png`,
    x2: `${STATIC_URL}/ico-bank-kwangju@2x.png`,
  },
  '035': {
    x1: `${STATIC_URL}/ico-bank-shinhan.png`,
    x2: `${STATIC_URL}/ico-bank-shinhan@2x.png`,
  },
  '081': {
    x1: `${STATIC_URL}/ico-bank-hana.png`,
    x2: `${STATIC_URL}/ico-bank-hana@2x.png`,
  },
  '301': {
    x1: `${STATIC_URL}/logo__card-301.png`,
    x2: `${STATIC_URL}/logo__card-301.png`,
  },
  '302': {
    x1: `${STATIC_URL}/logo__card-302.png`,
    x2: `${STATIC_URL}/logo__card-302.png`,
  },
  '303': {
    x1: `${STATIC_URL}/logo__card-303.png`,
    x2: `${STATIC_URL}/logo__card-303.png`,
  },
  '304': {
    x1: `${STATIC_URL}/logo__card-304.png`,
    x2: `${STATIC_URL}/logo__card-304.png`,
  },
  '305': {
    x1: `${STATIC_URL}/logo__card-305.png`,
    x2: `${STATIC_URL}/logo__card-305.png`,
  },
  '306': {
    x1: `${STATIC_URL}/logo__card-306.png`,
    x2: `${STATIC_URL}/logo__card-306.png`,
  },
  '307': {
    x1: `${STATIC_URL}/logo__card-307.png`,
    x2: `${STATIC_URL}/logo__card-307.png`,
  },
  '309': {
    x1: `${STATIC_URL}/logo__card-309.png`,
    x2: `${STATIC_URL}/logo__card-309.png`,
  },
  '311': {
    x1: `${STATIC_URL}/logo__card-311.png`,
    x2: `${STATIC_URL}/logo__card-311.png`,
  },
  '313': {
    x1: `${STATIC_URL}/logo__card-313.png`,
    x2: `${STATIC_URL}/logo__card-313.png`,
  },
  '315': {
    x1: `${STATIC_URL}/logo__card-315.png`,
    x2: `${STATIC_URL}/logo__card-315.png`,
  },
  '316': {
    x1: `${STATIC_URL}/logo__card-316.png`,
    x2: `${STATIC_URL}/logo__card-316.png`,
  },
  '320': {
    x1: `${STATIC_URL}/logo__card-320.png`,
    x2: `${STATIC_URL}/logo__card-320.png`,
  },
  '321': {
    x1: `${STATIC_URL}/logo__card-321.png`,
    x2: `${STATIC_URL}/logo__card-321.png`,
  },
  '0287': {
    x1: `${STATIC_URL}/image/ico-meritz.png`,
    x2: `${STATIC_URL}/image/ico-meritz.png`,
  },
  '0279': {
    x1: `${STATIC_URL}/image/ico-securities-db.png`,
    x2: `${STATIC_URL}/image/ico-securities-db.png`,
  },
  '0261': {
    x1: `${STATIC_URL}/image/ico-securities-kyobo.png`,
    x2: `${STATIC_URL}/image/ico-securities-kyobo.png`,
  },
  '0240': {
    x1: `${STATIC_URL}/image/ico-securities-samsung.png`,
    x2: `${STATIC_URL}/image/ico-securities-samsung.png`,
  },
  '0269': {
    x1: `${STATIC_URL}/image/ico-securities-hanhwa.png`,
    x2: `${STATIC_URL}/image/ico-securities-hanhwa.png`,
  },
  '0267': {
    x1: `${STATIC_URL}/image/ico-securities-daesin.png`,
    x2: `${STATIC_URL}/image/ico-securities-daesin.png`,
  },
  '0218': {
    x1: `${STATIC_URL}/image/ico-securities-kb.png`,
    x2: `${STATIC_URL}/image/ico-securities-kb.png`,
  },
  '0247': {
    x1: `${STATIC_URL}/image/ico-securities-nh.png`,
    x2: `${STATIC_URL}/image/ico-securities-nh.png`,
  },
  '0243': {
    x1: `${STATIC_URL}/image/ico-securities-hanguk.png`,
    x2: `${STATIC_URL}/image/ico-securities-hanguk.png`,
  },
  '0264': {
    x1: `${STATIC_URL}/image/ico-securities-kium.png`,
    x2: `${STATIC_URL}/image/ico-securities-kium.png`,
  },
  '0280': {
    x1: `${STATIC_URL}/image/ico-securities-yujin.png`,
    x2: `${STATIC_URL}/image/ico-securities-yujin.png`,
  },
  '0238': {
    x1: `${STATIC_URL}/image/ico-securities-mirae-asset.png`,
    x2: `${STATIC_URL}/image/ico-securities-mirae-asset.png`,
  },
  '0266': {
    x1: `${STATIC_URL}/image/ico-securities-sk.png`,
    x2: `${STATIC_URL}/image/ico-securities-sk.png`,
  },
  '0209': {
    x1: `${STATIC_URL}/image/ico-securities-yuanta.png`,
    x2: `${STATIC_URL}/image/ico-securities-yuanta.png`,
  },
  '1267': {
    x1: `${STATIC_URL}/image/ico-securities-creon.png`,
    x2: `${STATIC_URL}/image/ico-securities-creon.png`,
  },
  '0265': {
    x1: `${STATIC_URL}/image/ico-securities-ls.png`,
    x2: `${STATIC_URL}/image/ico-securities-ls.png`,
  },
  '0270': {
    x1: `${STATIC_URL}/image/ico-securities-hana.png`,
    x2: `${STATIC_URL}/image/ico-securities-hana.png`,
  },
  '0278': {
    x1: `${STATIC_URL}/image/ico-securities-sinhan.png`,
    x2: `${STATIC_URL}/image/ico-securities-sinhan.png`,
  },
  '1247': {
    x1: `${STATIC_URL}/image/ico-securities-namu.png`,
    x2: `${STATIC_URL}/image/ico-securities-namu.png`,
  },
  '0262': {
    x1: `${STATIC_URL}/image/ico-securities-high.png`,
    x2: `${STATIC_URL}/image/ico-securities-high.png`,
  },
  '0225': {
    x1: `${STATIC_URL}/image/ico-securities-ibk.png`,
    x2: `${STATIC_URL}/image/ico-securities-ibk.png`,
  },
  '0227': {
    x1: `${STATIC_URL}/image/ico-securities-daol.png`,
    x2: `${STATIC_URL}/image/ico-securities-daol.png`,
  },
};

export const ORGANIZATION_LOGOS_FOR_ALL: BankLogosForAll = {
  ...ORGANIZATION_LOGOS,
  '092': {
    x1: `${STATIC_URL}/image/toss-bank-logo.png`,
    x2: `${STATIC_URL}/image/toss-bank-logo.png`,
  },
};

export type OrganizationNames = (typeof ORGANIZATION_CODES)[keyof typeof ORGANIZATION_CODES];

export enum CardLoginType {
  LOGIN_ID = 'LOGIN_ID',
  CERTIFICATE = 'CERTIFICATE',
}

export const CARD_LOGIN_TYPE_BY_ORGANIZATION_CODE = {
  '002': [CardLoginType.CERTIFICATE],
  '301': [CardLoginType.LOGIN_ID],
  '302': [CardLoginType.LOGIN_ID],
  '303': [CardLoginType.LOGIN_ID],
  '304': [CardLoginType.LOGIN_ID],
  '305': [CardLoginType.LOGIN_ID],
  '306': [CardLoginType.LOGIN_ID],
  '307': [CardLoginType.CERTIFICATE],
  '309': [CardLoginType.LOGIN_ID],
  '311': [CardLoginType.LOGIN_ID],
  '313': [CardLoginType.LOGIN_ID],
  '315': [CardLoginType.CERTIFICATE],
  '316': [CardLoginType.LOGIN_ID],
  '320': [CardLoginType.CERTIFICATE],
  '321': [CardLoginType.CERTIFICATE],
};

export type OrgnizationDataCategory = 'BANK' | 'REVENUE' | 'CARD' | 'SECURITY';

export type Organization = {
  /** 기관 id */
  id: number;
  /** 기관 code */
  organizationCode: OrganizationCodes;
  /** 인증서 이름 */
  organizationName: string;
  /** 인증서 type */
  organizationType: 'BK' | 'NT' | 'CD' | 'ST';
  /** 인증서 category */
  organizationDataCategory: OrgnizationDataCategory;
};

export type Certificate = {
  /** 인증서 id */
  certificateId: number;
  /** 인증서 type */
  certificateType: string;
  /** 인증서 소유자 */
  certificateOwner: string;
  /** 인증서 만료 기간 */
  certificateExpireDate: string;
  /** 인증서 auth? */
  certificateAuthority: string;
  /** 인증서 기관 리스트 */
  organizationList: Organization[];
  status: CertificateStatus;
  isRevenueSource: boolean;
  createdAt: string;
  staledAt?: string;
  /** 사업자등록번호 */
  businessRegNumber?: string;
};

export type CertificateStatus = 'NORMAL' | 'EXPIRED' | 'STALE' | 'EXPIRE_SOON';
